export const emiratesTariffCodes = ['VANTRRU2', 'LLEEPRU1'];